<template>
  <v-card>
    <v-card-text>
      <h2>Date of birth</h2>
      <template v-if="!editDobFlag">
        <span v-if="entity.dob">{{ entity.dob.body | formatDate }}</span>
        <span v-if="!entity.dob">Not set</span>
        &#160;
        <a @click="editDob()">Change</a>
      </template>
      <div class="ajaxForm" v-if="editDobFlag">
        <v-text-field
          label="Date of birth"
          v-model="dobCopyText"
          hint="DD/MM/YYYY"
          v-mask="'##/##/####'"
          outline
        />
        <v-date-picker v-model="dobCopy" />
        <div>
          <v-btn @click="saveDob" :disabled="!dobCopy">Save</v-btn>
          <v-btn @click="editDobFlag = false">Cancel</v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import UPDATE_ENTITY_DETAIL_BY_TYPE from "@/graphql/directory/UpdateEntityDetailByType";
import { format, parse, formatISO, parseISO } from "date-fns";
export default {
  name: "Dob",
  props: ["entity"],
  data() {
    return {
      editDobFlag: false,
      dob: null,
      dobCopy: null,
      dobCopyText: null
    };
  },
  methods: {
    async saveDob() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_DETAIL_BY_TYPE,
        variables: {
          id: Number(this.$route.params.id),
          typeid: 15,
          value: this.dobCopy
        }
      });
      // console.log(response.data);
      this.editDobFlag = false;
      this.$emit("triggerUpdate");
    },
    editDob() {
      if (this.entity.dob) {
        this.dobCopy = this.entity.dob.body;
        this.dobCopyText = format(parseISO(this.entity.dob.body), "dd/MM/yyyy");
      } else {
        this.dobCopy = null;
        this.dobCopyText = null;
      }
      this.editDobFlag = true;
    }
  },
  watch: {
    dobCopyText: {
      handler() {
        try {
          const date = parse(this.dobCopyText, "dd/MM/yyyy", new Date());
          this.dobCopy =
            date == "Invalid Date"
              ? null
              : formatISO(date, { representation: "date" });
          // console.log(this.dobCopy);
        } catch (err) {
          console.log(err);
        }
      }
    }
  }
};
</script>
